import type { NoticePost } from '@/lib/types';
import type { ArticleView } from '@/pages/news/NoticeArticleBody';

/**
 * 팝업 공지를 다루는 함수 둘 — 화면 조각({@code NoticePopupLayout})과 나눠 두었다. 한 파일에
 * 섞으면 개발 중 새로고침이 통째로 다시 돈다({@code noticePopupOpener} 와 같은 이유).
 */

/** 공지 한 건을 본문 칸이 읽는 모양으로. 창·모달·목록에서 펼친 글이 모두 이것을 쓴다. */
export function articleOf(post: NoticePost): ArticleView {
  return {
    category: post.category,
    authorName: post.authorName,
    subjectName: post.subjectName,
    subjectDeptSite: post.subjectDeptSite,
    content: post.content,
    images: post.images,
    attachments: post.attachments,
    attachmentName: post.attachmentName,
    attachmentUrl: post.attachmentUrl,
    guidelineId: post.guidelineId,
  };
}

/** 세울 공지 여럿 — 최신 글이 위. */
export function newestFirst(posts: NoticePost[]): NoticePost[] {
  return [...posts].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
}
